module.exports = __webpack_public_path__ + "img/icn-login-panel.9bfd60c3.png";